import React from 'react';

import { WhatsappVerificationStep } from '../types';
import { WhatsappVerificationContextProvider } from './WhatsappVerificationContextProvider';

export function withWhatsappVerificationContextProvider<
  P = Record<string, unknown>,
>(WrappedComponent: React.ComponentType<P>) {
  const Wrapper = (props: P & JSX.IntrinsicAttributes) => {
    const currentStep: WhatsappVerificationStep | undefined =
      'initialStep' in props
        ? (props.initialStep as WhatsappVerificationStep)
        : undefined;
    return (
      <WhatsappVerificationContextProvider initialStep={currentStep}>
        <WrappedComponent {...props} />
      </WhatsappVerificationContextProvider>
    );
  };

  return Wrapper;
}
